export enum ImportStatus {
    PENDING = 1,
    ADDED = 2,
    LOADED = 3,
    FAILED = 4
}
